var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"real-page-loading"},[_c('div',{staticClass:"loading-progress",style:({ width: _vm.progress + '%', backgroundColor: '#e60012' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }